// extracted by mini-css-extract-plugin
export default {"container":"Ng-cl","item":"PfszW","label":"_2t7PL"};